module.exports = __webpack_public_path__ + "static/media/icon-support.48541fd1.svg";